export default __webpack_public_path__ + "static/media/learning-icon.a1b04da3.png";